import { useMemo } from "react";

export function GetYear() {
  return useMemo(() => new Date().getFullYear(), []);
}
